import { render, staticRenderFns } from "./UiSectionCard.vue?vue&type=template&id=151225ae&scoped=true"
import script from "./UiSectionCard.vue?vue&type=script&lang=js"
export * from "./UiSectionCard.vue?vue&type=script&lang=js"
import style0 from "./UiSectionCard.vue?vue&type=style&index=0&id=151225ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151225ae",
  null
  
)

export default component.exports